import {AppState} from './../../../store';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import {
  toggleLoadingDestinationsAction,
  updateDestinationsAction,
  updateDestinationsActionV2,
} from './actions';
import {IDestinationsStoreState} from './types';
import fetchVoyagerAutoSuggestions from '@stencil/hotels-utils/src/autoSuggest-utils/fetchVoyagerAutoSuggestions';

export function fetchDestinationsThunkV2({
  params = {inputValue: '', isByPassBlankInput: false},
  getNewUrl = arg => {},
}): ThunkAction<void, AppState, {}, AnyAction> {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(toggleLoadingDestinationsAction(true));
    try {
      const response = await fetchVoyagerAutoSuggestions(params, {}, getNewUrl);

      if (Array.isArray(response) && response?.length) {
        dispatch(updateDestinationsActionV2(response as IDestinationsStoreState['dataV2']));
      }
      dispatch(toggleLoadingDestinationsAction(false));
    } catch {
      dispatch(toggleLoadingDestinationsAction(false));
    }
  };
}
